import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const dispatch = {
  namespaced: true,
  state: {
    dispatchConfiguration: ''
  },
  getters,
  mutations,
  actions
}
